import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bbd059a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "express-way" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = { class: "express-top" }
const _hoisted_4 = { class: "express-bottom" }
const _hoisted_5 = {
  key: 0,
  class: "express-address public-style"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "express-title" }
const _hoisted_8 = { class: "express-title" }
const _hoisted_9 = {
  key: 0,
  class: "address-tip"
}
const _hoisted_10 = {
  key: 1,
  class: "express-set-default-address"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please choose your default door delivery address", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_13 = {
  key: 2,
  class: "express-set-default-address"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rider collection is currently not available, kindly choose Kilishop/ G4S from Top \"Shipment Method\" button.", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "select-time"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "express-title" }, "Expect Pickup time：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "calendar-bottom-tip" }, "For reference only, subject to the final express appointment time", -1))
const _hoisted_19 = { class: "tracking public-style" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "express-title" }, "Tracking No：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "select-county" }, "Please select country/city", -1))
const _hoisted_22 = { class: "pop-box" }
const _hoisted_23 = { class: "express-tip public-style" }
const _hoisted_24 = { class: "tip" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_KiliButton = _resolveComponent("KiliButton")!
  const _component_AfterType = _resolveComponent("AfterType")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_PointList = _resolveComponent("PointList")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_BottomBtn = _resolveComponent("BottomBtn")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Return the Product",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: $setup.skipPath,
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToRule && $setup.goToRule(...args)))
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["skipPath"]),
    _createVNode(_component_van_form, {
      class: "refund-content",
      "validate-first": "",
      onFailed: $setup.onFailed,
      onSubmit: $setup.onSubmit,
      ref: "wayForm",
      clearable: "",
      autofocus: "",
      "show-error-message": false,
      "show-error": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_field, {
            modelValue: $setup.expressWay.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.expressWay.title) = $event)),
            class: _normalizeClass($setup.expressWay.title ? 'express-cell' : ''),
            "is-link": "",
            "input-align": "right",
            readonly: "",
            label: "Shipment Method:",
            "label-width": "40%",
            placeholder: "plesae choose",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeReasonList('expressWay')))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          ($setup.expressWay.name == '2' || $setup.expressWay.name == '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("span", _hoisted_7, "Recipient Information:", 512), [
                    [_vShow, $setup.expressWay.name == '1']
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_8, "Address:", 512), [
                    [_vShow, $setup.expressWay.name == '2']
                  ]),
                  ($setup.expressWay.name == '2')
                    ? (_openBlock(), _createBlock(_component_KiliButton, {
                        key: 0,
                        plain: "",
                        textColor: "#DD3131",
                        bordersColor: "#DD3131",
                        radiusSize: "8px",
                        title: "Select",
                        onClick: $setup.editAddress
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                ($setup.existDefaultAddress&&!$setup.addressData.length&&$setup.expressWay.name == '2')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, "please select a collection address."))
                  : _createCommentVNode("", true),
                ($setup.expressWay.name == '2'&&!$setup.existDefaultAddress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", {
                        class: "go-btn-text",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.editAddress(true)))
                      }, "Click here")
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_AfterType, {
                  data: $setup.addressData,
                  lefterSize: "0.3rem"
                }, _createSlots({ _: 2 }, [
                  _renderList($setup.addressData, (item) => {
                    return {
                      name: "titleLeft",
                      fn: _withCtx(() => [
                        _hoisted_12,
                        _createElementVNode("span", null, "+" + _toDisplayString($setup.phoneCode) + " ", 1),
                        _createElementVNode("span", null, _toDisplayString(item.phone), 1)
                      ])
                    }
                  })
                ]), 1032, ["data"]),
                ($setup.addressData.length&&$setup.expressWay.name == '2'&&($setup.addressData[0]?.dlyp_id > 0 || !$setup.addressData[0]?.area_pickup))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : _createCommentVNode("", true),
                ($setup.expressWay.name == '2')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_van_field, {
                        modelValue: $setup.pickupTime,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.pickupTime) = $event)),
                        "is-link": "",
                        readonly: "",
                        "left-icon": "notes-o",
                        name: "calendar",
                        placeholder: "please choose",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showObj.showCalendar = true)),
                        rules: [{ required: true, message: 'Please select the arrival date' }]
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_van_calendar, {
                        "show-title": false,
                        show: $setup.showObj.showCalendar,
                        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (($setup.showObj.showCalendar) = $event)),
                        onConfirm: $setup.handleCalendar,
                        "show-confirm": false
                      }, null, 8, ["show", "onConfirm"]),
                      _hoisted_18
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.expressWay.name == '1')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_van_field, {
                  modelValue: $setup.logistics.title,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.logistics.title) = $event)),
                  class: _normalizeClass($setup.logistics.title ? 'express-cell' : ''),
                  "is-link": "",
                  "input-align": "right",
                  readonly: "",
                  label: "Logistics provider:",
                  "label-width": "40%",
                  placeholder: "plesae choose"
                }, null, 8, ["modelValue", "class"]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_van_field, {
                    ref: "trackRef",
                    modelValue: $setup.trackingNo,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.trackingNo) = $event)),
                    placeholder: "Please enter the logistics tracking number.",
                    type: "text",
                    clearable: "",
                    rules: [
                                { required: true, message: 'Please enter the logistics tracking number' },
                                {  validator: $setup.validatorTrack, message: 'The tracking No. format is incorrect, please follow the prompts to re-enter the tracking No. in the correct format.' }
                        
                        ]
                  }, null, 8, ["modelValue", "rules"])
                ])
              ], 64))
            : _createCommentVNode("", true),
          ($setup.expressWay.name == '3')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_van_field, {
                  modelValue: $setup.pickupUserInfo.contact_name,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.pickupUserInfo.contact_name) = $event)),
                  type: "text",
                  name: "contactName",
                  label: "Name",
                  "input-align": "right",
                  placeholder: "Please enter your contact name",
                  rules: [{ required: true, message: 'Please enter your contact name' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  class: "cantact-phone",
                  modelValue: $setup.pickupUserInfo.contact_phone,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.pickupUserInfo.contact_phone) = $event)),
                  type: "tel",
                  name: "contactPhone",
                  label: "Phone",
                  "input-align": "right",
                  placeholder: "Please enter a phone number",
                  rules: [{ required: true, message: 'Please enter a phone number' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.pickScoped.county,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.pickScoped.county) = $event)),
                  "is-link": "",
                  name: "County",
                  placeholder: "County",
                  readonly: "",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.handleCounty('county'))),
                  rules: [{ required: true, message: 'Please select a county' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.pickScoped.town,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.pickScoped.town) = $event)),
                  "is-link": "",
                  name: "Town",
                  placeholder: "Town",
                  readonly: "",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.handleCounty('town'))),
                  rules: [{ required: true, message: 'Please select a town' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  class: "express-popup",
                  show: $setup.showObj.showPicker,
                  "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (($setup.showObj.showPicker) = $event)),
                  position: "bottom",
                  closeable: "",
                  "close-icon": "close"
                }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_van_radio_group, {
                        modelValue: $setup.countyCheck,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.countyCheck) = $event)),
                        class: "radio-box"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_cell_group, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countyData, (item) => {
                                return (_openBlock(), _createBlock(_component_van_cell, {
                                  title: item.area_name,
                                  clickable: "",
                                  onClick: ($event: any) => ($setup.checkedCounty(item, 'add'))
                                }, {
                                  "right-icon": _withCtx(() => [
                                    _createVNode(_component_van_radio, {
                                      name: item.area_id
                                    }, null, 8, ["name"])
                                  ]),
                                  _: 2
                                }, 1032, ["title", "onClick"]))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["show"]),
                ($setup.pickScoped.county && $setup.pickScoped.town)
                  ? (_openBlock(), _createBlock(_component_PointList, {
                      key: 0,
                      pointData: $setup.pickupData,
                      pickupCheck: $setup.pickupCheck,
                      phoneCode: $setup.phoneCode,
                      onUpdate: $setup.handleUpdate
                    }, null, 8, ["pointData", "pickupCheck", "phoneCode", "onUpdate"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, _toDisplayString($setup.tipContent.title) + ":", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tipContent.text, (item) => {
              return (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(item.value), 1))
            }), 256)),
            ($setup.tipContent.img?.length)
              ? (_openBlock(), _createBlock(_component_van_image, {
                  key: 0,
                  width: "100%",
                  src: $setup.tipContent.img,
                  fit: "cover"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onFailed", "onSubmit"]),
    ($setup.expressWay.title)
      ? (_openBlock(), _createBlock(_component_BottomBtn, {
          key: 0,
          onClick: $setup.handleBtn,
          btnData: $setup.btnData
        }, null, 8, ["onClick", "btnData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: $setup.showObj.showDialog,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => (($setup.showObj.showDialog) = $event)),
      class: "after-dialog",
      closeable: "",
      onClose: $setup.closePopup
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tipContent.text, (item) => {
          return (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(item.value), 1))
        }), 256)),
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.popupBtnData, (btnItem) => {
            return (_openBlock(), _createBlock(_component_KiliButton, {
              plain: btnItem.plain,
              textColor: btnItem.textColor,
              bordersColor: btnItem.bordersColor,
              title: btnItem.title,
              loading: btnItem.loading,
              onClick: ($event: any) => ($setup.handlePopupBtn(btnItem))
            }, null, 8, ["plain", "textColor", "bordersColor", "title", "loading", "onClick"]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.showObj.showAction,
      "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => (($setup.showObj.showAction) = $event)),
      title: $setup.sheetTitle,
      closeable: false,
      round: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_radio_group, {
          modelValue: $setup.selectAction,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.selectAction) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectTypeList, (item) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    title: item.title,
                    clickable: "",
                    onClick: ($event: any) => ($setup.handleReasonRadio(item))
                  }, {
                    "right-icon": _withCtx(() => [
                      _createVNode(_component_van_radio, {
                        name: item.name
                      }, null, 8, ["name"])
                    ]),
                    _: 2
                  }, 1032, ["title", "onClick"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}